import {UIService} from "../UIService";
import {ProductDataService} from "../../services/productDataService";
import {ProductDataStore} from "../../stores/productDataStore";
import {PacketService} from "./packetService";
import {AccessoryUIService} from "../accessoryComponent/accessoryUIService";
import {AppStateService} from "../../services/appStateService";
import {ComponentUIServiceVisibilityInterface} from "../../interfaces/ComponentUIServiceVisibilityInterface";
import {EventService} from "../../services/eventService";

export class PacketUIService implements ComponentUIServiceVisibilityInterface
{
    private uiService: UIService;
    private productDataService: ProductDataService;
    private packetService: PacketService;
    private productDataStore: ProductDataStore;
    private accessoryUIService: AccessoryUIService;
    private appStateService: AppStateService;
    private eventService: EventService;

    constructor()
    {
        this.uiService = new UIService();
        this.productDataService = new ProductDataService();
        this.packetService = new PacketService();
        this.productDataStore = new ProductDataStore();
        this.accessoryUIService = new AccessoryUIService();
        this.appStateService = new AppStateService();
        this.eventService = new EventService();

        this.refreshComponentTemplate();
        // this.uiService
        //     .getResetButtonByModule('packet')
        //     .addEventListener('click', (event: any) => {
        //         this.packetService.reset();
        //         this.refreshSelectedOptions();
        //         this.accessoryUIService.refreshSelectedOptions();
        //     });

        this.eventService.getTarget().addEventListener('sizeChange', (data) => {
            this.refreshPrices();
        });
    }

    componentDontHaveOptions() {
        return this.productDataStore.getAvailableOptionsByName('packet').length === 0;
    }

    public refreshComponentTemplate()
    {
        this.uiService.refreshElementsInModule('packets');
    }

    public refreshSelectedOptions()
    {
        const selected = this.productDataStore.getSelectedOptionByName('packet');
        this.uiService.resetSelectionsByPartName('packet');
        this.uiService.setSelectedOptions('packet', selected);
    }

    public initializePacketComponent()
    {

        if (this.componentDontHaveOptions()) {
            this.appStateService.setAppSettingTemplateFlag('app', 'packetsComponent', false);
            this.uiService.refreshElementsInModule('app');
            this.uiService.hideConfiguratorMenuElement('packets');
            return;
        }

        this.packetService.validate();

        const packets = this.productDataStore.getAvailableOptionsByName('packet');

        packets.forEach((packet) => {
            let packetParts = [];

            if (packet.relationships.handle !== undefined) {
                packetParts.push(this.productDataStore.getAvailableOptionByNameAndId(
                    'handle',
                    packet.relationships.handle.data.id,
                ));
            }
            if (packet.relationships.glazingSpacers !== undefined) {
                packetParts.push(this.productDataStore.getAvailableOptionByNameAndId(
                    'glazingSpacers',
                    packet.relationships.glazingSpacers.data.id,
                ));
            }
            packet.relationships.accessories.data.forEach((packetAccessory) => {
                packetParts.push(
                    this.productDataStore.getAvailableOptionByNameAndId(
                        'accessory',
                        packetAccessory.id,
                    )
                )
            });
            const option = this.createOption(
                packet,
                packetParts
            );

            if (this.productDataStore.getSelectedOptionIdByName('packet').includes(packet.id)) {
                this.uiService.setSelectedOption(option);
            }

            option.addEventListener('click', (event: any) => {
                const selectedPackets = this.packetService.toggle(packet.id);
                this.uiService.resetSelectionsByPartName('packet');
                this.uiService.setSelectedOptions('packet', selectedPackets);
                this.accessoryUIService.refreshSelectedOptions();
                this.accessoryUIService.refreshComponentTemplate();
                this.packetService.validate();
                this.uiService.removeElementsByPartName('packet');
                this.initializePacketComponent();
            });
        });
        this.initializeModal();
        this.eventService.getTarget().addEventListener('updatePacketPrices', (data) => {
            this.refreshPrices();
        });
    }

    private initializeModal()
    {
        const closeButton = document
            .querySelector('.configuratorComponent[nf-component-name="packets"]')
            .querySelector(`[nf-action="closePacketDetailsModal"]`);

        closeButton.addEventListener('click', (event: any) => {
            this.appStateService.setAppSettingTemplateFlag('packets', 'packetDetailsModal', false);
            this.uiService.refreshElementsInModule('packets');
        });
    }

    private createOptionIncluded(
        option: HTMLElement,
        templateName: string,
        includedDetails: any
    ) {
        const includedTemplate = option.querySelector(`[nf-configurator-option-template="${templateName}"]`);
        const includedOption = includedTemplate.cloneNode(true) as HTMLElement;
        const selectedGlazing = this.productDataStore.getAvailableOptionByNameAndId(
            'glazing',
            this.productDataStore.getSelectedOptionIdByName('glazing')
        );

        if (includedDetails.attributes) {
            // handle/accessory
            this.uiService.setAttributeToElement(
                includedOption,
                'nf-option-id',
                includedDetails.id
            );
            if (includedDetails.attributes.imgSrc) {
                this.uiService.setAttributeToElement(
                    this.uiService.getElementByAttribute(
                        'nf-value-key',
                        'img',
                        includedOption
                    ),
                    'src',
                    includedDetails.attributes.imgSrc
                );
            }
            this.uiService.addTextInElement(
                this.uiService.getElementByAttribute(
                    'nf-value-key',
                    'name',
                    includedOption
                ),
                includedDetails.attributes.name
            );
            this.uiService.addTextInElement(
                this.uiService.getElementByAttribute(
                    'nf-value-key',
                    'currentPrice',
                    includedOption
                ),
                (includedDetails.attributes.price ?? 0)
            );
            this.uiService.addTextInElement(
                this.uiService.getElementByAttribute(
                    'nf-value-key',
                    'netPrice',
                    includedOption
                ),
                (includedDetails.attributes.netPrice ?? 0)
            );
        } else {
            // glazing spacer
            const glazingSpacerImg = `image_${selectedGlazing.attributes.chambers}_glass`;

            if (includedDetails[glazingSpacerImg]) {
                this.uiService.setAttributeToElement(
                    this.uiService.getElementByAttribute('nf-value-key', 'img', includedOption),
                    'src',
                    `/files/glazingspacers/${includedDetails[glazingSpacerImg]}`
                );
            }

            this.uiService.setAttributeToElement(
                includedOption,
                'nf-option-id',
                includedDetails.id
            );

            this.uiService.addTextInElement(
                this.uiService.getElementByAttribute(
                    'nf-value-key',
                    'name',
                    includedOption
                ),
                includedDetails.name
            );
            this.uiService.addTextInElement(
                this.uiService.getElementByAttribute(
                    'nf-value-key',
                    'currentPrice',
                    includedOption
                ),
                includedDetails.priceAfterDiscount
            );
            this.uiService.addTextInElement(
                this.uiService.getElementByAttribute(
                    'nf-value-key',
                    'netPrice',
                    includedOption
                ),
                includedDetails.netPriceAfterDiscount
            );
        }
        includedOption.removeAttribute('nf-configurator-option-template');
        includedTemplate.parentNode.appendChild(includedOption);
    }

    private createOption(
        packet,
        packetParts
    ) {
        const option = this.uiService.createConfiguratorOption('packet');
        const readMoreButton = option.querySelector(`[nf-action="openPacketReadMoreModal"]`);

        readMoreButton.addEventListener('click', (event: any) => {
            this.uiService.replaceTextInElement(
                this.uiService.getElementByAttribute(
                    'nf-value-key',
                    'modalTitle',
                    document.querySelector(
                        '.configuratorComponent[nf-component-name="packets"]'
                    ),
                ),
                packet.attributes.name
            );
            this.uiService.replaceTextInElement(
                this.uiService.getElementByAttribute(
                    'nf-value-key',
                    'modalContent',
                    document.querySelector(
                        '.configuratorComponent[nf-component-name="packets"]'
                    ),
                ),
                packet.attributes.modalContent
            );
            this.appStateService.setAppSettingTemplateFlag('packets', 'packetDetailsModal', true);
            this.uiService.refreshElementsInModule('packets');

            event.preventDefault();
            event.stopPropagation();

            return false;
        });

        if (Object.keys(packetParts).length !== 0) {
            packetParts.forEach((part) => {
                let type = 'packetGlazingSpacer';

                if (part.attributes) {
                    type = part.type;
                }
                this.createOptionIncluded(
                    option,
                    type,
                    part,
                );
            });
        }
        if (packet.attributes.isBlocked) {
            option.classList.add('--blocked');
        }
        this.uiService.setAttributeToElement(
            option,
            'nf-option-id',
            packet.id
        );
        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'name',
                option
            ),
            packet.attributes.name
        );
        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'price',
                option
            ),
            0
        );
        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'saving',
                option
            ),
            0
        );
        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'netPrice',
                option
            ),
            0
        );
        this.uiService.addTextInElement(
            this.uiService.getElementByAttribute(
                'nf-value-key',
                'netSaving',
                option
            ),
            0
        );

        return option;
    }

    private refreshPrices()
    {
        const packetsPrices = this.appStateService.getPrices().filter(function(part) {
            return part.type && part.type === 'packet';
        });

        packetsPrices.forEach((packetPrice) => {
            const element = this.uiService.getElementByPartNameAndId(
                'packet',
                packetPrice.id
            );
            // b2c price
            this.uiService.replaceTextInElement(
                this.uiService.getElementByAttribute(
                    'nf-value-key',
                    'currentPrice',
                    element,
                ),
                '+' + (packetPrice.attributes.price_normal ?? 0) + ' kr'
            );
            this.uiService.replaceTextInElement(
                this.uiService.getElementByAttribute(
                    'nf-value-key',
                    'currentSaving',
                    element,
                ),
                (
                    Math.floor(
                        packetPrice.attributes.price_normal - packetPrice.attributes.price_packet
                    )
                ) + ' kr'
            );
            // b2b price
            this.uiService.replaceTextInElement(
                this.uiService.getElementByAttribute(
                    'nf-value-key',
                    'netPrice',
                    element,
                ),
                '+' + (packetPrice.attributes.net_price_normal ?? 0) + ' kr'
            );
            this.uiService.replaceTextInElement(
                this.uiService.getElementByAttribute(
                    'nf-value-key',
                    'netSaving',
                    element,
                ),
                (
                    Math.floor(
                        packetPrice.attributes.net_price_normal - packetPrice.attributes.net_price_packet
                    )
                ) + ' kr'
            );
            // regular price
            this.uiService.replaceTextInElement(
                this.uiService.getElementByAttribute(
                    'nf-value-key',
                    'regularPrice',
                    element,
                ),
                '+' + (packetPrice.attributes.regularPrice ?? 0) + ' kr'
            );
            this.uiService.replaceTextInElement(
                this.uiService.getElementByAttribute(
                    'nf-value-key',
                    'regularSaving',
                    element,
                ),
                (
                    Math.floor(
                        packetPrice.attributes.regularNormalPrice - packetPrice.attributes.regularPrice
                    )
                ) + ' kr'
            );

            const glazingSpacers = this.uiService.getElementsByPartName('packetGlazingSpacer');

            glazingSpacers.forEach((glazingSpacerOption) => {
                const glazingSpacerId: any = glazingSpacerOption.getAttribute('nf-option-id');
                const glazingSpacer = this.productDataStore.getAvailableOptionByNameAndId('glazingSpacers', glazingSpacerId);

                this.uiService.replaceTextInElement(
                    this.uiService.getElementByAttribute(
                        'nf-value-key',
                        'currentPrice',
                        glazingSpacerOption
                    ),
                    this.packetService.getGlazingSpacerPrice(glazingSpacer.priceAfterDiscount)
                );
                this.uiService.replaceTextInElement(
                    this.uiService.getElementByAttribute(
                        'nf-value-key',
                        'netPrice',
                        glazingSpacerOption
                    ),
                    this.packetService.getGlazingSpacerPrice(glazingSpacer.netPriceAfterDiscount)
                );
            });
        });
    }
}
